import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Activity.css';

function Activity() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');

  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'rides', label: 'Rides' },
    { id: 'services', label: 'Services' },
    { id: 'orders', label: 'Orders' }
  ];

  const activities = [
    {
      id: 1,
      type: 'ride',
      title: 'Ride to Penn Station',
      subtitle: 'Economy • 12 miles',
      date: 'Nov 29, 2024',
      time: '3:45 PM',
      status: 'completed',
      price: 8.00,
      icon: '🚗',
      driver: 'Alex J.'
    },
    {
      id: 2,
      type: 'service',
      title: 'Math Tutoring Session',
      subtitle: 'Calculus II Help',
      date: 'Nov 28, 2024',
      time: '2:00 PM',
      status: 'completed',
      price: 25.00,
      icon: '📚',
      provider: 'Sarah W.'
    },
    {
      id: 3,
      type: 'ride',
      title: 'Ride to Newark Airport',
      subtitle: 'Comfort • 18 miles',
      date: 'Nov 25, 2024',
      time: '6:00 AM',
      status: 'completed',
      price: 15.00,
      icon: '🚗',
      driver: 'James C.'
    },
    {
      id: 4,
      type: 'order',
      title: 'Marketplace Purchase',
      subtitle: 'TI-84 Calculator',
      date: 'Nov 22, 2024',
      time: '11:30 AM',
      status: 'completed',
      price: 85.00,
      icon: '🛒',
      seller: 'Mike R.'
    },
    {
      id: 5,
      type: 'service',
      title: 'Resume Review',
      subtitle: 'Career Services',
      date: 'Nov 20, 2024',
      time: '4:00 PM',
      status: 'completed',
      price: 15.00,
      icon: '📄',
      provider: 'Emily B.'
    }
  ];

  const filteredActivities = activeTab === 'all'
    ? activities
    : activities.filter(a => a.type === activeTab.slice(0, -1));

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return '#00c966';
      case 'pending': return '#f97316';
      case 'cancelled': return '#ef4444';
      default: return '#888';
    }
  };

  return (
    <div className="activity-page">
      {/* Header */}
      <header className="activity-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1>My Activity</h1>
        <button className="filter-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </header>

      {/* Tabs */}
      <div className="activity-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`activity-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Activity List */}
      <div className="activity-list">
        {filteredActivities.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">📋</span>
            <h3>No activity yet</h3>
            <p>Your orders and rides will appear here</p>
          </div>
        ) : (
          filteredActivities.map((activity) => (
            <div key={activity.id} className="activity-card">
              <div className="activity-card-header">
                <div className="activity-icon">
                  <span>{activity.icon}</span>
                </div>
                <div className="activity-main">
                  <h3 className="activity-title">{activity.title}</h3>
                  <p className="activity-subtitle">{activity.subtitle}</p>
                </div>
                <div className="activity-price">
                  ${activity.price.toFixed(2)}
                </div>
              </div>

              <div className="activity-card-footer">
                <div className="activity-meta">
                  <span className="activity-date">{activity.date}</span>
                  <span className="activity-dot">•</span>
                  <span className="activity-time">{activity.time}</span>
                </div>
                <div
                  className="activity-status"
                  style={{ color: getStatusColor(activity.status) }}
                >
                  {activity.status}
                </div>
              </div>

              <div className="activity-card-actions">
                <button className="action-btn">View Details</button>
                <button className="action-btn">Book Again</button>
                {activity.status === 'completed' && (
                  <button className="action-btn rate">Rate</button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Activity;
